export const imagesProperty = (property: {
  IMAGES: {
    file: unknown;
    url: string;
    title: string;
    distance: string;
    available: string;
    fee: string;
    link: string;
  }[];
  id: any;
  title: string;
  price: number;
}) => {
  const result: {
    id: any,
    url: string;
    title: string;
    distance: string;
    available: string;
    fee: string;
    link: string;
    ratings: any
  }[] = [];
  property.IMAGES.map((i) => {
    const image = {
      id: null,
      url: i.url,
      title: property.title,
      distance: "",
      available: "",
      fee: "$" + property.price.toLocaleString(
        "de-DE",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      ),
      link: "#",
      ratings: []
    };
    result.push(image);
  });
  return result;
};
